import { validateAndTriggerEvent } from "../listener";
import { Types } from "../types";
export var tierSelectionMeta = {
    "gtm": true,
    "deprecated": false,
    "name": "tierSelection",
    "origName": "tierSelection"
};
var tierSelectionContextNames = [];
export var tierSelectionEventSchema = Types.object.of({
    tier: Types.object.of({
        rank: Types.number.isRequired,
        entitlementSetId: Types.string.isRequired,
    }).isRequired,
});
/**
 * Trigger tierSelection event
 *
 * Scope - track selection of a tier that users perform on the tierselectionpage or directly on LP/OB. Triggering condition - event is fired every time a user selects a subscription tier by either sumbitting the tier selection form or when auth-web-chapter codebase is loaded and the tier was already selected on landingpage/openbrowse.
 *
 * @param {Object} payload
 * @param {Object} payload.tier - string
 * @param {number} payload.tier.rank - string
 * @param {string} payload.tier.entitlementSetId - string
 * @returns {undefined}
 */
export function triggerTierSelectionEvent(payload) {
    return validateAndTriggerEvent(tierSelectionMeta, tierSelectionEventSchema, payload, tierSelectionContextNames);
}
//# sourceMappingURL=tierSelectionEvent.js.map